module.exports = __webpack_public_path__ + "static/media/exchangeIco.65eed523.svg";